import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProductDetail from "../pages/product/page";
import Auth from "../pages/auth/page";
import Cart from "../pages/cart/page";
import Checkout from "../pages/checkout/page";
import OrderConfirmation from "../pages/order-confirmation/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import FAQ from "../pages/faq/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import TermsConditions from "../pages/terms-conditions/page";
import RefundPolicy from "../pages/refund-policy/page";
import OrlistatProduct from "../pages/products/orlistat/page";
import AmoxicillinProduct from "../pages/products/amoxicillin/page";
import IbuprofenProduct from "../pages/products/ibuprofen/page";
import Viagra100mg from "../pages/products/viagra-100mg/page";
import Viagra150mg from "../pages/products/viagra-150mg/page";
import Viagra200mg from "../pages/products/viagra-200mg/page";
import Viagra250mg from "../pages/products/viagra-250mg/page";
import Soma350mg from "../pages/products/soma-350mg/page";
import Soma350mgRx from "../pages/products/soma-350mg-rx/page";
import Soma500mg from "../pages/products/soma-500mg/page";
import Soma500mgOverseas from "../pages/products/soma-500mg-overseas/page";
import Cialis20mg from "../pages/products/cialis-20mg/page";
import Cialis40mg from "../pages/products/cialis-40mg/page";
import Cialis60mg from "../pages/products/cialis-60mg/page";
import Cialis80mg from "../pages/products/cialis-80mg/page";
import Levitra20mg from "../pages/products/levitra-20mg/page";
import Levitra40mg from "../pages/products/levitra-40mg/page";
import Levitra60mg from "../pages/products/levitra-60mg/page";
import KamagraOralJelly from "../pages/products/kamagra-oral-jelly/page";
import Tapentadol100mg from "../pages/products/tapentadol-100mg/page";
import Tapentadol100mgUS from "../pages/products/tapentadol-100mg-us/page";
import Tapentadol200mg from "../pages/products/tapentadol-200mg/page";
import Tapentadol200mgUS from "../pages/products/tapentadol-200mg-us/page";
import Zoltrate10mg from "../pages/products/zoltrate-10mg/page";
import Zolpidem10mg from "../pages/products/zolpidem-10mg/page";
import Alprazolam05mg from "../pages/products/alprazolam-0.5mg/page";
import VitaminD35000IU from "../pages/products/vitamin-d3-5000iu/page";
import TadalistaSuperActive20mg from "../pages/products/tadalista-super-active-20mg/page";
import Vidalista20mg from "../pages/products/vidalista-20mg/page";
import AllProducts from "../pages/all-products/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/faq",
    element: <FAQ />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms-conditions",
    element: <TermsConditions />,
  },
  {
    path: "/refund-policy",
    element: <RefundPolicy />,
  },
  {
    path: "/all-products",
    element: <AllProducts />,
  },
  {
    path: "/product",
    element: <ProductDetail />,
  },
  {
    path: "/products/orlistat",
    element: <OrlistatProduct />,
  },
  {
    path: "/products/amoxicillin",
    element: <AmoxicillinProduct />,
  },
  {
    path: "/products/ibuprofen",
    element: <IbuprofenProduct />,
  },
  {
    path: "/products/viagra-100mg",
    element: <Viagra100mg />,
  },
  {
    path: "/products/viagra-150mg",
    element: <Viagra150mg />,
  },
  {
    path: "/products/viagra-200mg",
    element: <Viagra200mg />,
  },
  {
    path: "/products/viagra-250mg",
    element: <Viagra250mg />,
  },
  {
    path: "/products/cialis-20mg",
    element: <Cialis20mg />,
  },
  {
    path: "/products/cialis-40mg",
    element: <Cialis40mg />,
  },
  {
    path: "/products/cialis-60mg",
    element: <Cialis60mg />,
  },
  {
    path: "/products/cialis-80mg",
    element: <Cialis80mg />,
  },
  {
    path: "/products/levitra-20mg",
    element: <Levitra20mg />,
  },
  {
    path: "/products/levitra-40mg",
    element: <Levitra40mg />,
  },
  {
    path: "/products/levitra-60mg",
    element: <Levitra60mg />,
  },
  {
    path: "/products/kamagra-oral-jelly",
    element: <KamagraOralJelly />,
  },
  {
    path: "/products/soma-350mg",
    element: <Soma350mg />,
  },
  {
    path: "/products/soma-350mg-rx",
    element: <Soma350mgRx />,
  },
  {
    path: "/products/soma-500mg",
    element: <Soma500mg />,
  },
  {
    path: "/products/soma-500mg-overseas",
    element: <Soma500mgOverseas />,
  },
  {
    path: "/products/tapentadol-100mg",
    element: <Tapentadol100mg />,
  },
  {
    path: "/products/tapentadol-100mg-us",
    element: <Tapentadol100mgUS />,
  },
  {
    path: "/products/tapentadol-200mg",
    element: <Tapentadol200mg />,
  },
  {
    path: "/products/tapentadol-200mg-us",
    element: <Tapentadol200mgUS />,
  },
  {
    path: "/products/zoltrate-10mg",
    element: <Zoltrate10mg />,
  },
  {
    path: "/products/zolpidem-10mg",
    element: <Zolpidem10mg />,
  },
  {
    path: "/products/alprazolam-0.5mg",
    element: <Alprazolam05mg />,
  },
  {
    path: "/products/vitamin-d3-5000iu",
    element: <VitaminD35000IU />,
  },
  {
    path: "/products/tadalista-super-active-20mg",
    element: <TadalistaSuperActive20mg />,
  },
  {
    path: "/products/vidalista-20mg",
    element: <Vidalista20mg />,
  },
  {
    path: "/auth",
    element: <Auth />,
  },
  {
    path: "/cart",
    element: <Cart />,
  },
  {
    path: "/checkout",
    element: <Checkout />,
  },
  {
    path: "/order-confirmation",
    element: <OrderConfirmation />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
